import { ShieldCheck } from "lucide-react";

export const HALAL_OFFERS = [
  { title: "Traiteur africain halal", text: "Grillades, sauces mijotées, plats généreux d'Afrique de l'Ouest et centrale, préparés avec des viandes halal." },
  { title: "Traiteur antillais halal", text: "Accras, colombo, saveurs créoles et épicées des Antilles, en version halal." },
  { title: "Traiteur français halal", text: "Les classiques de la gastronomie française, raffinés et élégants, entièrement halal." },
  { title: "Traiteur afro-caribéen halal", text: "Le meilleur des deux rives : une cuisine métissée, festive et colorée, halal." },
];

const THEMES = {
  light: { section: "bg-white", card: "bg-[#FAF6EF] border-[#C9A84C]/40", title: "text-[#2C2C2C]", text: "text-[#2C2C2C]/70", eyebrow: "text-[#9A7B2C]", note: "text-[#2C2C2C]/60" },
  ivory: { section: "bg-[#FAF6EF]", card: "bg-white border-[#C9A84C]/40", title: "text-[#2C2C2C]", text: "text-[#2C2C2C]/70", eyebrow: "text-[#9A7B2C]", note: "text-[#2C2C2C]/60" },
  dark: { section: "bg-[#2C2C2C] border-y border-white/10", card: "bg-white/[0.04] border-[#C9A84C]/40", title: "text-[#FAF6EF]", text: "text-white/70", eyebrow: "text-[#C9A84C]", note: "text-white/55" },
};

export const HalalSection = ({ variant = "light", title = "Votre traiteur halal, du mariage au dîner privé", intro, testId = "halal-section" }) => {
  const t = THEMES[variant];
  return (
    <section className={`${t.section} py-20 lg:py-28`} data-testid={testId}>
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#C9A84C] text-[#2C2C2C]"><ShieldCheck size={26} strokeWidth={1.5} /></span>
          <p className={`text-sm uppercase tracking-[0.3em] ${t.eyebrow}`}>Notre offre principale : le halal</p>
          <h2 className={`mt-4 font-serif text-3xl font-500 lg:text-5xl ${t.title}`}>{title}</h2>
          <p className={`mt-5 text-base leading-relaxed lg:text-lg ${t.text}`}>
            {intro || "Le halal est au cœur de notre cuisine. Africaine, antillaise, française ou afro-caribéenne : chaque prestation est pensée en halal, pour que tous vos invités partagent le même repas en toute confiance."}
          </p>
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {HALAL_OFFERS.map((o, i) => (
            <div key={o.title} className={`reveal rounded-2xl border p-7 ${t.card}`} style={{ transitionDelay: `${i * 80}ms` }} data-testid={`${testId}-card-${i}`}>
              <span className="inline-block rounded-full bg-[#C9A84C] px-3 py-1 text-xs font-medium uppercase tracking-wider text-[#2C2C2C]">Halal</span>
              <h3 className={`mt-4 font-serif text-2xl ${t.title}`}>{o.title}</h3>
              <p className={`mt-3 text-sm leading-relaxed ${t.text}`}>{o.text}</p>
            </div>
          ))}
        </div>
        <p className={`reveal mt-8 text-center text-sm ${t.note}`} data-testid={`${testId}-non-halal`}>Une option non halal est également disponible sur demande.</p>
      </div>
    </section>
  );
};
